import React from "react";
import { motion } from "framer-motion";
interface RevealProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  as?: "div" | "section" | "li" | "article";
}

// Subtle, professional fade-and-rise on scroll. No parallax, no bounce.
export function Reveal({
  children,
  className,
  delay = 0
}: RevealProps) {
  return <motion.div className={className} initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: "-80px"
  }} transition={{
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1],
    delay
  }} data-id="element-242" data-mp="thrfbznmlg4s">
      {children}
    </motion.div>;
}